import { Suspense } from 'react'
import { MainPage } from 'components/templates/MainPage'
import { useParams } from 'react-router-dom'
import { LoadingOverlay } from 'components/atoms/overlay/LoadingOverlay'
import { CompanyDetailForm } from './CompanyDetailForm'
export const CompanyUpdate = (): JSX.Element | null => {
  const { companyId } = useParams()

  return (
    <MainPage>
      <Suspense fallback={<LoadingOverlay />}>
        {companyId ? <CompanyDetailForm companyId={companyId} /> : <></>}
      </Suspense>
    </MainPage>
  )
}
